import Echo from 'laravel-echo';

import Pusher from 'pusher-js';
import { getCookie } from '@/utils/cookie';
window.Pusher = Pusher;

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: import.meta.env.VITE_REVERB_PORT,
  wssPort: import.meta.env.VITE_REVERB_PORT,
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  authEndpoint: import.meta.env.VITE_REVERB_AUTH_ENDPOINT,
  auth: {
    headers: {
      Authorization: 'Bearer ' + getCookie('token'),
      Accept: 'application/json',
    },
  },
  enabledTransports: ['ws', 'wss'],
});
